import React from 'react'
import DomainsContainer from './styles/DomainsContainer';
import DomainCard from './common/DomainCard'
import {Title} from '../components/common/title'

const Domains = ({ data }) => {
    const mate = data.mate;
    const cunoastereaMediului = data.cunoastereaMediului;
    const limbaj = data.limbaj;
    const estetic = data.estetic;
    const socioEmotional = data.socioEmotional;
    const edFizica = data.edFizica;
    const ala = data.ala;
    const tranzitii = data.tranzitii;
    const pedagogie = data.pedagogie;

    return (
        <DomainsContainer>
            <Title>Domenii</Title>
            <div className="cardGroup">
                <DomainCard
                    title="Științe - Matematică"
                    text={mate.totalCount
                        ? `${mate.distinct.length} lecți${mate.distinct.length === 1 ? "e" : "i"} și 
                        ${mate.totalCount} ${mate.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#FEF0FF'}
                    link="/domeniu/matematica"
                    key="Stiinte - Matematica"
                />
                <DomainCard
                    title="Științe - Cunoașterea Mediului"
                    text={cunoastereaMediului.totalCount
                        ? `${cunoastereaMediului.distinct.length} lecți${cunoastereaMediului.distinct.length === 1 ? "e" : "i"} 
                        și ${cunoastereaMediului.totalCount} ${cunoastereaMediului.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}

                    background={'#EAFBFC'}
                    link="/domeniu/cunoasterea-mediului"
                    key="Stiinte - Mediu"
                />
                <DomainCard
                    title="Limbă și Comunicare"
                    text={limbaj.totalCount
                        ? `${limbaj.distinct.length} lecți${limbaj.distinct.length === 1 ? "e" : "i"} 
                            și ${limbaj.totalCount} ${limbaj.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#FEF0FF'}
                    link="/domeniu/limbaj"
                    key="Limba si Comunicare"
                />
                <DomainCard
                    title="Estetic și Creativ"
                    text={estetic.totalCount
                        ? `${estetic.distinct.length} lecți${estetic.distinct.length === 1 ? "e" : "i"} 
                            și ${estetic.totalCount} ${estetic.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#EAFBFC'}
                    link="/domeniu/estetic"
                    key="Estetic și Creativ"
                />
                <DomainCard
                    title="Educație Fizică"
                    text={edFizica.totalCount
                        ? `${edFizica.distinct.length} lecți${edFizica.distinct.length === 1 ? "e" : "i"} 
                            și ${edFizica.totalCount} ${edFizica.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#FEF0FF'}
                    link="/domeniu/fizic"
                    key="Educatie Fizica"
                />
                <DomainCard
                    title="Socio-Emoțional"
                    text={socioEmotional.totalCount
                        ? `${socioEmotional.distinct.length} lecți${socioEmotional.distinct.length === 1 ? "e" : "i"} 
                            și ${socioEmotional.totalCount} ${socioEmotional.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#EAFBFC'}
                    link="/domeniu/socio-emotional"
                    key="Socio-Emoțional"
                />
                <DomainCard
                    title="Rutine și Tranziții"
                    text={tranzitii.totalCount
                        ? `${tranzitii.distinct.length} lecți${tranzitii.distinct.length === 1 ? "e" : "i"} 
                            și ${tranzitii.totalCount} ${tranzitii.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#FEF0FF'}
                    link="/domeniu/tranzitii"
                    key="Rutine si Tranzitii"
                />
                <DomainCard
                    title="Activități Liber Alese"
                    text={ala.totalCount
                        ? `${ala.distinct.length} lecți${ala.distinct.length === 1 ? "e" : "i"} 
                            și ${ala.totalCount} ${ala.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#EAFBFC'}
                    link="/domeniu/ala"
                    key="Activitati Liber Alese"
                />
                <DomainCard
                    title="Bune Practici de Predare"
                    text={pedagogie.totalCount
                        ? `${pedagogie.distinct.length} lecți${pedagogie.distinct.length === 1 ? "e" : "i"} 
                            și ${pedagogie.totalCount} ${pedagogie.totalCount === 1 ? "fișă" : "fișe"} yummy`
                        : "în curând..."}
                    background={'#FEF0FF'}
                    link="/domeniu/pedagogie"
                    key="Bune Practici de Predare"
                />
            </div>
        </DomainsContainer>
    )
}

export default Domains;